var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.params.data.has_attachments)?_c('i',{staticClass:"fas fa-paperclip"}):_c('span',[_vm._v("N/A")])])}
var staticRenderFns = []

export { render, staticRenderFns }